import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Paper, Card, CardMedia, CardContent, Link, Divider, CircularProgress, Tabs, Tab, Chip, Dialog, DialogTitle, IconButton, DialogContent } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CloseIcon from '@mui/icons-material/Close';
import apiClient from '../../utils/apiClient';

const ViewShowroomDetails = () => {
    const location = useLocation();
    const showroom = location.state?.showroomId || {};
    const [showroomDetails, setShowroomDetails] = useState([]);
    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false)


    const getShowroomById = async () => {
        try {
            setLoading(true)
            const response = await apiClient.get(`/showroom/showroom/showroomdetails/${showroom}`);
            if (response?.data?.status === true) {
                setShowroomDetails(response?.data?.showroom)
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || ' Error Occured');
        }
        finally {
            setLoading(false)
        }
    }
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const [serviceSubTab, setServiceSubTab] = useState(0);

    const handleServiceSubTabChange = (event, newValue) => {
        setServiceSubTab(newValue);
    };

    const [open, setOpen] = useState(false);
    const [selectedDoc, setSelectedDoc] = useState(null);

    const handleOpen = (doc) => {
        setSelectedDoc(doc);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedDoc(null);
    };
    const isImageLike = (path) => /\.(jpg\d*|jpeg\d*|png\d*|gif\d*|webp\d*)$/i.test(path);
    const isPDF = (path) => /\.pdf$/i.test(path);

    const { name, brand,
        description, address, contact, email, rating, locationLat, locationLng, isActive,
        isOnline, isPopular, isVerified, isMobileVerified, registeredFrom, createdAt, images = [], documents = [], skillServices = [], skillPackageServices = [], completedAssignedWorks, cancelledAssignedWorks, totalWorkAssigned, commissionPercentage, bankDetails
    } = showroomDetails;

    useEffect(() => {
        getShowroomById();
    }, [showroom])

    if (!showroom) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
                <CircularProgress />
                <Typography mt={2}>Loading Technicain data...</Typography>
            </Box>
        );
    }






    return (
        <>
            <Box p={4}>
                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }} onClick={() => navigate(-1)}>
                        <ArrowLeft size={18} color="#333" />
                        <Typography variant="body1" sx={{ ml: 1 }}>Back</Typography>
                    </Box>
                    <Typography
                        variant="h4"
                        sx={{
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)'
                        }}
                    >
                        Service Center Details
                    </Typography>
                </Box>

                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ mb: 3 }}
                >
                    <Tab label="Profile" />
                    <Tab label="Status" />
                    <Tab label="Work Summary" />
                    <Tab label="Images" />
                    <Tab label="Documents" />
                    <Tab label="Services" />
                    <Tab label='Bank Details' />

                </Tabs>

                {/* Tab Content */}
                {tabIndex === 0 && (
                    <Box>
                        <Typography variant="h6" gutterBottom>Basic Information</Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Name:</strong> {name}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Brand:</strong> {brand}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Contact:</strong> {contact}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Email:</strong> {email}</Typography></Grid>
                            <Grid item size={12}><Typography><strong>Description:</strong> {description}</Typography></Grid>
                            <Grid item size={12}><Typography><strong>Address:</strong> {address}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Rating:</strong> {rating}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Created At:</strong> {createdAt}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Registered From:</strong> {registeredFrom}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Location:</strong> Lat: {locationLat}, Lng: {locationLng}</Typography></Grid>
                        </Grid>
                    </Box>
                )}

                {tabIndex === 1 && (
                    <Box>
                        <Typography variant="h6" gutterBottom>Status & Verification</Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Active:</strong> {isActive ? 'Yes' : 'No'}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Online:</strong> {isOnline ? 'Yes' : 'No'}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Popular:</strong> {isPopular ? 'Yes' : 'No'}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Verified:</strong> {isVerified ? 'Yes' : 'No'}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Mobile Verified:</strong> {isMobileVerified ? 'Yes' : 'No'}</Typography></Grid>
                        </Grid>
                    </Box>
                )}

                {tabIndex === 2 && (
                    <Box>
                        <Typography variant="h6" gutterBottom>Work Summary</Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Total Work Assigned:</strong> {totalWorkAssigned}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Completed Works:</strong> {completedAssignedWorks}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Cancelled Works:</strong> {cancelledAssignedWorks}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}><Typography><strong>Commission (%):</strong> {commissionPercentage ?? 'N/A'}</Typography></Grid>
                        </Grid>
                    </Box>
                )}

                {tabIndex === 3 && (
                    <Box>
                        <Typography variant="h6" gutterBottom>Images</Typography>
                        <Divider sx={{ mb: 2 }} />
                        {images?.length > 0 ? (
                            <Grid container spacing={2}>

                                {images.map((img) => (
                                    <Grid item size={{ xs: 3, sm: 2, md: 2 }} key={img.id}>
                                        <img src={img.imageUrl} alt={img.name} style={{ width: '80px', height: '80px', borderRadius: 5, border: '1px solid #ccc' }} />
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '200px' }}>
                                <Grid item>
                                    <p>No images found</p>
                                </Grid>
                            </Grid>
                        )}
                    </Box>
                )}

                {tabIndex === 4 && (
                    <Box>
                        <Typography variant="h6" gutterBottom>Documents</Typography>
                        <Divider sx={{ mb: 2 }} />

                        {documents?.length > 0 ? (
                            <Grid container spacing={2}>
                                {documents.map((doc) => (
                                    <Grid item size={{ xs: 12, md: 4, sm: 6 }} key={doc.id}>
                                        <Box sx={{ border: '1px solid #ccc', p: 2, borderRadius: 1 }}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                <strong>{doc.documentName}</strong>
                                            </Typography>

                                            {/* Thumbnail preview (optional) */}
                                            {isImageLike(doc.documentPath) ? (
                                                <img
                                                    src={doc.documentPath}
                                                    alt={doc.documentName}
                                                    style={{
                                                        width: '100%',
                                                        height: '150px',
                                                        objectFit: 'cover',
                                                        borderRadius: 4,
                                                        marginBottom: '8px',
                                                    }}
                                                />
                                            ) : isPDF(doc.documentPath) ? (
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        height: '160px',
                                                        backgroundColor: '#f5f5f5',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderRadius: 2,
                                                        marginBottom: '8px',
                                                    }}
                                                >
                                                    <Typography variant="body2">📄 PDF File</Typography>
                                                </Box>
                                            ) : null}


                                            <Typography
                                                onClick={() => handleOpen(doc)}
                                                sx={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline', mt: 1 }}
                                            >
                                                View Document
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '200px' }}>
                                <Grid item>
                                    <Typography>No documents found</Typography>
                                </Grid>
                            </Grid>
                        )}
                    </Box>
                )}



                {tabIndex === 5 && (
                    <Grid item size={12}>
                        <Typography variant="h6">Services & Package Services</Typography>
                        <Divider sx={{ mb: 1 }} />

                        {/* Sub Tabs */}
                        <Tabs value={serviceSubTab} onChange={handleServiceSubTabChange} sx={{ mb: 2 }}>
                            <Tab label="Services" />
                            <Tab label="Package Services" />
                        </Tabs>

                        {/* Services Tab */}
                        {serviceSubTab === 0 && (
                            <>
                                {skillServices?.length > 0 ? (
                                    <Grid container spacing={1}>
                                        {skillServices?.map((skill, index) => (
                                            <Grid item key={index}>
                                                <Chip label={skill?.service?.name || `Skill ${index + 1}`} />
                                            </Grid>
                                        ))}
                                    </Grid>
                                ) : (
                                    <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100px' }}>
                                        <Grid item><p>No services found</p></Grid>
                                    </Grid>
                                )}
                            </>
                        )}

                        {/* Package Services Tab */}
                        {serviceSubTab === 1 && (
                            <>
                                {skillPackageServices?.length > 0 ? (
                                    <Grid container spacing={1}>
                                        {skillPackageServices?.map((skill, index) => (
                                            <Grid item key={index}>
                                                <Chip label={skill?.packageService?.name || `Package ${index + 1}`} />
                                            </Grid>
                                        ))}
                                    </Grid>
                                ) : (
                                    <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100px' }}>
                                        <Grid item><p>No package services found</p></Grid>
                                    </Grid>
                                )}
                            </>
                        )}
                    </Grid>
                )}
                {tabIndex === 6 && (
                    <Grid item size={12}>
                        <Typography variant="h6">BankDetails</Typography>
                        <Divider sx={{ mb: 1 }} />
                        {bankDetails ? (

                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Account Holder Name:</b> {bankDetails?.accountHolderName}</Typography></Grid>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Account Number:</b> {bankDetails?.accountNumber}</Typography></Grid>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Bank Name:</b> {bankDetails?.bankName}</Typography></Grid>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>IFSCCode:</b> {bankDetails?.ifscCode}</Typography></Grid>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Is Deleted:</b> {bankDetails?.isDeleted ? 'Yes' : 'No'}</Typography></Grid>
                            </Grid>
                        ) : (<Grid container justifyContent="center" alignItems="center" style={{ minHeight: '200px' }}>
                            <Grid item>
                                <p>No  bank details found</p>
                            </Grid>
                        </Grid>)}
                    </Grid>
                )}

                {errors &&
                    <Typography variant='body2' color='error'>{errors}</Typography>}




            </Box>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <DialogTitle>
                    {selectedDoc?.documentName}
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedDoc && isImageLike(selectedDoc.documentPath) ? (
                        <img
                            src={selectedDoc.documentPath}
                            alt={selectedDoc.documentName}
                            style={{ width: '100%', borderRadius: 4 }}
                        />
                    ) : selectedDoc && isPDF(selectedDoc.documentPath) ? (
                        <iframe
                            src={selectedDoc.documentPath}
                            title={selectedDoc.documentName}
                            width="100%"
                            height="600px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <Typography>Preview not available</Typography>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ViewShowroomDetails;
